import { render } from "./Finances.vue?vue&type=template&id=14c895c0&scoped=true"
import script from "./Finances.vue?vue&type=script&lang=js"
export * from "./Finances.vue?vue&type=script&lang=js"

import "./Finances.vue?vue&type=style&index=0&id=14c895c0&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c895c0"]])

export default __exports__